import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.config';

const fullConfig = resolveConfig(tailwindConfig);

export function strlSetCookie(cname, cvalue, exdays) {
	// eslint-disable-line
	const d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	let expires = 'expires=' + d.toUTCString();
	document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

export function strlGetCookie(cname) {
	// eslint-disable-line
	let name = cname + '=';
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return '';
}

export function mediaQuery(screen) {
	let media = '';

	if ('sm' === screen) {
		media = `(max-width:${fullConfig.theme.screens.md})`;
	}

	if ('md' === screen) {
		media = `(min-width:${fullConfig.theme.screens.md}) and (max-width:${fullConfig.theme.screens.lg})`;
	}

	if ('md-up' === screen) {
		media = `(min-width:${fullConfig.theme.screens.md})`;
	}

	if ('lg' === screen) {
		media = `(min-width:${fullConfig.theme.screens.lg} and (max-width:${fullConfig.theme.screens.xl})`;
	}

	if ('lg-up' === screen) {
		media = `(min-width:${fullConfig.theme.screens.lg})`;
	}

	if ('xl' === screen) {
		media = `(min-width:${fullConfig.theme.screens.xl})`;
	}

	return media ? window.matchMedia(media).matches : false;
}

export function slideUp(target, duration = 300) {
	console.log('slide Up');
	if (target.style.display === 'none') {
		return;
	}
	target.style.transitionProperty = 'height, margin, padding';
	target.style.transitionDuration = duration + 'ms';
	target.style.boxSizing = 'border-box';
	target.style.height = target.offsetHeight + 'px';
	target.offsetHeight;
	target.style.overflow = 'hidden';
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	window.setTimeout(() => {
		target.style.display = 'none';
		target.style.removeProperty('height');
		target.style.removeProperty('padding-top');
		target.style.removeProperty('padding-bottom');
		target.style.removeProperty('margin-top');
		target.style.removeProperty('margin-bottom');
		target.style.removeProperty('overflow');
		target.style.removeProperty('transition-duration');
		target.style.removeProperty('transition-property');
		//alert("!");
	}, duration);
}

export function slideDown(target, duration = 300) {
	console.log('slide DOwn');
	if (target.style.display === 'block') {
		return;
	}
	target.style.removeProperty('display');
	let display = window.getComputedStyle(target).display;

	if (display === 'none') display = 'block';

	target.style.display = display;
	let height = target.offsetHeight;
	target.style.overflow = 'hidden';
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	target.offsetHeight;
	target.style.boxSizing = 'border-box';
	target.style.transitionProperty = 'height, margin, padding';
	target.style.transitionDuration = duration + 'ms';
	target.style.height = height + 'px';
	target.style.removeProperty('padding-top');
	target.style.removeProperty('padding-bottom');
	target.style.removeProperty('margin-top');
	target.style.removeProperty('margin-bottom');
	window.setTimeout(() => {
		target.style.removeProperty('height');
		target.style.removeProperty('overflow');
		target.style.removeProperty('transition-duration');
		target.style.removeProperty('transition-property');
	}, duration);
}

export function slideToggle(target, duration = 300) {
	if (window.getComputedStyle(target).display === 'none') {
		return slideDown(target, duration);
	} else {
		return slideUp(target, duration);
	}
}

const submenuToggles = document.querySelectorAll('.submenu-toggle');

submenuToggles.forEach((toggle) => {
	toggle.addEventListener('click', (e) => {
		e.preventDefault();
		const parentLi = toggle.closest('.menu-item-has-children');
		const subMenu = parentLi.querySelector('.sub-menu');

		if (subMenu) {
			slideToggle(subMenu);

			toggle.classList.toggle('rotate-180');

			const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
			toggle.setAttribute('aria-expanded', !isExpanded);
		}
	});
});

export function strlAddReadspeaker(client_id) {
	if (client_id.length === 0) {
		return;
	}
	const script = document.createElement('script');
	script.type = 'text/javascript';
	script.src = '//cdn-eu.readspeaker.com/script/' + client_id + '/webReader/webReader.js';
	script.id = 'rs_req_Init';
	document.head.appendChild(script);
	window.rsConf = window.rsConf || {};
	window.rsConf = {
		settings: {
			hltoggle: 'hloff',
		},
		general: { usePost: true },
		ui: { tools: { translation: false } },
	};
}
